function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBarbecueColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 390.271 390.271",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFC10D"
    },
    d: "M296.954,120.307c-5.43,55.273-52.04,98.069-108.412,98.069c-56.889,0-103.499-43.378-108.929-98.069 H296.954z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#56ACE0"
    },
    d: "M311.046,348.509c0-11.378-9.244-20.04-20.04-20.04c-11.378,0-20.04,9.244-20.04,20.04 c0,11.378,9.244,20.04,20.04,20.04C302.384,368.549,311.046,359.305,311.046,348.509z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M291.006,306.23c-0.517,0-1.616,0-2.198,0l-29.22-87.855 c35.232-23.273,59.087-63.418,59.087-109.446c0-5.947-4.848-10.861-10.861-10.861H68.234c-5.947,0-10.861,4.848-10.861,10.861 c0,45.511,23.273,85.657,59.087,109.446L64.485,376.113c-1.616,5.43,1.099,11.895,7.046,13.576 c5.947,1.616,11.895-1.099,13.576-7.047l28.186-86.174h149.592l5.43,16.808c-11.378,7.564-18.941,20.622-18.941,35.232 c0,23.273,18.941,41.762,41.762,41.762c23.273,0,41.762-18.941,41.762-41.762C332.703,325.172,314.279,306.23,291.006,306.23z  M79.612,120.307h217.341c-5.43,55.273-52.04,98.069-108.412,98.069C131.653,218.376,85.042,175.063,79.612,120.307z  M120.275,274.747l15.192-46.093c16.291,7.046,33.616,10.861,52.558,10.861c18.424,0,36.331-3.814,52.558-10.861l15.192,46.093 H120.275z M291.006,368.549c-11.378,0-20.04-9.244-20.04-20.04c0-11.378,9.244-20.04,20.04-20.04c11.378,0,20.04,9.244,20.04,20.04 C311.046,359.305,302.384,368.549,291.006,368.549z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M188.024,47.127c5.947,0,10.861-4.848,10.861-10.861V10.861C198.885,4.913,194.036,0,188.024,0 c-5.947,0-10.861,4.848-10.861,10.861v25.471C177.164,42.279,182.077,47.127,188.024,47.127z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M122.99,90.505c5.947,0,10.861-4.848,10.861-10.861V54.174c0-5.947-4.848-10.861-10.861-10.861 c-6.012,0-10.861,4.848-10.861,10.861v25.471C112.129,85.657,117.042,90.505,122.99,90.505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#194F82"
    },
    d: "M253.059,90.505c5.947,0,10.861-4.848,10.861-10.861V54.174c0-5.947-4.849-10.861-10.861-10.861 c-5.947,0-10.861,4.848-10.861,10.861v25.471C242.198,85.657,247.111,90.505,253.059,90.505z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarbecueColor);
export default __webpack_public_path__ + "static/media/barbecue_color.feaed3ce21e54de666d0b44409572b87.svg";
export { ForwardRef as ReactComponent };